var map = {
	"./upload-add-img.png": 382,
	"./upload-cliente.png": 2257,
	"./upload-default.png": 2258,
	"./upload-dpi.png": 2259,
	"./upload-foto.png": 479,
	"./upload-recibo.png": 2260
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2256;